var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FF0000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580 5099 c-111 -18 -171 -59 -341 -228 -127 -127 -162 -168 -187 -221 -62 -129 -62 -270 0 -400 29 -59 102 -135 847 -882 l815 -818 -815 -818 c-745 -747 -818 -823 -847 -882 -62 -130 -62 -271 0 -400 25 -53 60 -94 187 -221 197 -197 240 -222 397 -227 112 -5 169 8 254 56 28 16 351 331 858 836 l812 810 818 -815 c956 -954 870 -884 1082 -884 122 0 127 1 195 34 59 29 95 59 226 190 127 127 162 168 187 221 62 129 62 270 0 400 -29 59 -102 135 -847 882 l-815 818 815 818 c745 747 818 823 847 882 62 130 62 271 0 400 -25 53 -60 94 -187 221 -127 127 -168 162 -221 187 -129 62 -270 62 -400 0 -59 -29 -135 -102 -882 -847 l-818 -815 -817 816 c-755 753 -823 818 -883 846 -36 17 -95 36 -130 41 -73 12 -74 12 -150 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/RedCross.4c681e14fc7c842b86154220bebb5958.svg";
export { ForwardRef as ReactComponent };